var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        [
          _c(_vm.component, {
            tag: "component",
            attrs: { eduInfo: _vm.eduInfo },
            on: {
              "update:eduInfo": function ($event) {
                _vm.eduInfo = $event
              },
              "update:edu-info": function ($event) {
                _vm.eduInfo = $event
              },
            },
          }),
        ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }